module.exports = __webpack_public_path__ + "icons/original/large/large-a3.2f39989763b3636f69b02ba2b53fbe44.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a3.png
// module id = 4I4A
// module chunks = app